export default __webpack_public_path__ + "static/media/login-title.071698c8.svg";